var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',[_c('b-row',[_c('div',{staticClass:"fancy-scroll",staticStyle:{"max-height":"70vh","overflow-y":"auto"}},[_c('b-col',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }